export const commandState = $state({
  isSiriOpen: false,
  query: ''
});

export function toggleSiri() {
  commandState.isSiriOpen = !commandState.isSiriOpen;
  if (!commandState.isSiriOpen) {
    commandState.query = '';
  }
}

export function closeSiri() {
  commandState.isSiriOpen = false;
  commandState.query = '';
}
